import { baseConfig } from "config";
import { getAccessToken } from "services/auth";
import { RegistrationState } from "store/features/registration/types";
import { Requester } from "./requester";

export const createNewPartner = async (
	id: string,
	name: string,
	fiscal_id: string,
	fcm_token: string | null
) => {
	const access_token = await getAccessToken();
	return createOrUpdatePartner(access_token, id, name, fiscal_id, fcm_token);
};

export const updatePartnerFcmToken = async (
	access_token: string,
	partnerId: string,
	newFcmToken: string
) => {
	const partnerData: any = await getPartnerWithAccessToken(
		access_token,
		partnerId
	);

	const { name, fiscal_id } = partnerData;

	return createOrUpdatePartner(
		access_token,
		partnerId,
		name,
		fiscal_id,
		newFcmToken
	);
};

const createOrUpdatePartner = async (
	access_token: string | null,
	id: string,
	name: string,
	fiscal_id: string,
	fcm_token: string | null
) => {
	const requestData = { name, fiscal_id, fcm_token };

	if (!id) {
		return Requester.post({
			url: `${baseConfig.baseURL}/partner/`,
			token: `${access_token}`,
			tokenType: "Bearer",
			body: requestData,
			success: (result): RegistrationState => {
				return result;
			},
			error: (error) => {
				throw error;
			}
		});
	}

	return Requester.put({
		url: `${baseConfig.baseURL}/partner/${id}/`,
		token: `${access_token}`,
		tokenType: "Bearer",
		body: requestData,
		success: (result): RegistrationState => {
			return result;
		},
		error: (error) => {
			throw error;
		}
	});
};

export const getPartner = async (partnerId: string) => {
	const access_token = await getAccessToken();
	return getPartnerWithAccessToken(access_token, partnerId);
};

export const getPartnerWithAccessToken = async (
	access_token: string,
	partnerId: string
) => {
	return Requester.get({
		url: `${baseConfig.baseURL}/partner/${partnerId}/`,
		token: access_token,
		tokenType: "Bearer",
		success: (result) => result,
		error: (error) => {
			throw error;
		}
	});
};
